var map = {
	"./-1.jpg": 517,
	"./0.jpg": 518,
	"./1.jpg": 519,
	"./10.jpg": 520,
	"./2.jpg": 521,
	"./3.jpg": 522,
	"./4.jpg": 523,
	"./5.jpg": 524,
	"./6.jpg": 525,
	"./7.jpg": 526,
	"./8.jpg": 527,
	"./9.jpg": 528,
	"./aris.jpg": 454,
	"./atamd.jpg": 455,
	"./belgeler.jpg": 456,
	"./bilge.jpg": 457,
	"./erdem.jpg": 458,
	"./hoyuk.jpg": 459,
	"./kitap.jpg": 529,
	"./tdkbelleten.jpg": 460,
	"./ttkbelleten.jpg": 461,
	"./turkdili.jpg": 462,
	"./turkdunyasi.jpg": 463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 447;